import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/axios';
import './TrialBanner.css';

/**
 * Banner die trial-status en licentiecode-invoer toont.
 *
 * Props:
 *  - trialEndsAt: ISO timestamp van einde proefperiode
 *  - licenseActive: boolean
 *  - onLicenseActivated: callback na succesvolle activatie
 */
const TrialBanner = ({ trialEndsAt, licenseActive, onLicenseActivated }) => {
  const [licenseKey, setLicenseKey] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  // Niet tonen als licentie actief is
  if (licenseActive) return null;
  // Niet tonen als er geen trial-datum is (bestaande gebruikers zonder trial)
  if (!trialEndsAt) return null;

  const now = new Date();
  const trialEnd = new Date(trialEndsAt);
  const trialActive = trialEnd > now;
  const daysLeft = Math.max(0, Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24)));

  const handleActivate = async (e) => {
    e.preventDefault();
    if (!licenseKey.trim()) return;
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      const res = await api.post('/api/auth/activate-license', { license_key: licenseKey.trim() });
      if (res.data.success) {
        setSuccess('Licentie geactiveerd!');
        setLicenseKey('');
        if (onLicenseActivated) onLicenseActivated();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Activatie mislukt.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`trial-banner ${trialActive ? 'trial-banner--active' : 'trial-banner--expired'}`}>
      <div className="trial-banner__message">
        {trialActive ? (
          <>
            <span>
              <strong>Proefperiode:</strong> U heeft nog <strong>{daysLeft}</strong> {daysLeft === 1 ? 'dag' : 'dagen'} over.
              Voer een licentiecode in om onbeperkt te blijven gebruiken.
            </span>
            <span className="trial-banner__hint">Wil je een licentie? Dien een verzoek in via <Link to="/instellingen">Instellingen</Link>.</span>
          </>
        ) : (
          <>
            <span>
              <strong>Uw proefperiode is verlopen.</strong> Voer uw licentiecode in om verder te gaan, of dien een licentieverzoek in via Instellingen.
            </span>
            <span className="trial-banner__hint">Wil je een licentie? Dien een verzoek in via <Link to="/instellingen">Instellingen</Link>.</span>
          </>
        )}
      </div>
      <form className="trial-banner__form" onSubmit={handleActivate}>
        <input
          type="text"
          className="trial-banner__input"
          placeholder="Licentiecode (bijv. LIC-ABC123...)"
          value={licenseKey}
          onChange={(e) => setLicenseKey(e.target.value)}
        />
        <button type="submit" className="trial-banner__btn" disabled={loading || !licenseKey.trim()}>
          {loading ? 'Bezig...' : 'Activeer'}
        </button>
      </form>
      {error && <div className="trial-banner__error">{error}</div>}
      {success && <div className="trial-banner__success">{success}</div>}
    </div>
  );
};

export default TrialBanner;
